import { styled } from 'styled-components';
import { LiaGripLinesVerticalSolid } from 'react-icons/lia';

const Container = styled.div`
  position: relative;
  height: 100%;
  border-left: 1px solid ${(props) => props.theme.global.borderColor};
`;

const Bar = styled.div`
  position: absolute;
  top: 0;
  left: -4px;
  width: 8px;
  z-index: 99;
  height: 100%;
  color: ${(props) => props.theme.global.whiteTextColor};
  font-size: 16px;
  justify-content: space-around;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: col-resize;
`;

const Handler = styled.div`
  position: absolute;
  top: 50%;
  transform: translate(-100%, -50%);
  width: 16px;
  height: 80px;
  background-color: ${(props) => props.theme.global.bgColor};
  border: 1px solid ${(props) => props.theme.global.borderColor};
  border-right: none;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  cursor: col-resize;

  display: flex;
  align-items: center;
  justify-content: flex-end;
  svg {
    color: ${(props) => props.theme.global.lightTextColor};
    font-size: 14px;
  }
`;

interface ResizeBarProps {
  onMouseDown: (event: React.MouseEvent) => void;
}

const ResizeBar = ({ onMouseDown }: ResizeBarProps) => {
  return (
    <Container>
      <Bar onMouseDown={onMouseDown} className="no-dragging"></Bar>
      <Handler onMouseDown={onMouseDown} className="no-dragging">
        <LiaGripLinesVerticalSolid />
      </Handler>
    </Container>
  );
};

export default ResizeBar;
